require("./style.css");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            theme: {
                bg: 'white',
                color: 'text-darken-2 grey',
                btn: 'light'
            },
            wsElement: null,
            multipleFiles: false,
            activeFileIndex: 0,
            alert: false,
            assets: false,
            editTool: false,
            editImage: false,
            showDoneBtn: false,
            showAssets: false,
            uploading: false
        };
        GState.bind(this, [
            'screen',
            'vts'
        ]);
        this.allDone = this.allDone.bind(this);
        this.cancelAll = this.cancelAll.bind(this);
    },
    onInput: function (input) {
        if (input.multiset)
            this.state.multipleFiles = [];
        switch (input.theme) {
        case 'dark':
            this.state.theme = {
                bg: 'theme-bg',
                color: 'white',
                btn: 'light'
            };
            break;
        default:
            this.state.theme = {
                bg: 'theme-bg',
                color: 'text-darken-2 grey',
                btn: 'light'
            };
        }
    },
    toWorkspace: function (asset, index, update) {
        this.state.wsElement = asset;
        this.state.showDoneBtn = true;
        if (typeof index == 'number') {
            this.state.activeFileIndex = index;
            if (update)
                this.state.multipleFiles[index] = asset;
            return;
        }
        if (this.input.multiset) {
            if (update) {
                this.state.multipleFiles[this.state.activeFileIndex] = asset;
                return;
            }
            this.state.multipleFiles.push(asset);
            this.state.activeFileIndex = index == 'first' ? 0 : this.state.multipleFiles.length - 1;
        }
    },
    showAlert: function (message) {
        this.state.alert = message;
        console.log('[PosterPlus] Error: ' + message);
        setTimeout(() => this.state.alert = false, 15000);
    },
    fromCloud: function () {
        this.state.showAssets = true;
        if (!this.state.assets)
            this.displayCDNAssets(this.input.cdn);
    },
    displayCDNAssets: function (type) {
        $.get('/assets?type=' + (type || '')).done(({error, message, results}) => {
            if (error)
                throw new Error('[PosterPlus] Failed to Fetch CDN Assets: ', message);
            this.state.assets = results.length ? results : null;
        }).fail(error => {
            console.log('[PosterPlus] Failed to Fetch CDN Assets: ', error);
            this.state.assets = null;
        });
    },
    closeCDNAssets: function () {
        this.state.showAssets = false;
    },
    fromComputer: function () {
        $('#pp-from-computer').click();
    },
    prevenAutoSubmit: function (e) {
        e.preventDefault();
    },
    mountSelectedFiles: function (e) {
        const files = $(e.target)[0].files;
        if (!files || !files.length)
            return this.cancelAll();
        const mount = (file, callback) => {
            this.toWorkspace({
                raw: file,
                src: URL.createObjectURL(file),
                size: file.size,
                mime: file.type,
                lastModified: file.lastModified
            }, 'first');
            typeof callback == 'function' && callback();
        };
        this.input.multiset ? Array.from(files).map(each => mount(each)) : mount(files[0], () => {
            if (!/\.(png|jp(e?)g|webp|gif)/.test(files[0].name))
                return;
            const {width, height} = this.input, ratio = width / height;
            !!ratio && this.mountEditImage({ ratio });
        });
    },
    mountEditImage: function ({ratio}) {
        const {width, height} = this.input;
        if (!ratio)
            ratio = width / height;
        this.state.editImage = {
            zoom: 0,
            rotate: 0,
            dimensions: {
                width,
                height
            },
            ratio,
            autoCrop: !!ratio || false
        };
        this.state.editTool = 'image';
        this.toCrop = false;
        const cParams = {
            autoCrop: this.state.editImage.autoCrop,
            ready: () => {
                this.toCrop = this.image.data('cropper');
                this.toWorkspace({
                    ...this.state.wsElement,
                    original: this.toCrop.getImageData()
                }, this.state.activeFileIndex, true);
            }
        };
        if (this.state.editImage.ratio)
            cParams.aspectRatio = this.state.editImage.ratio;
        this.state.wElement = '...';
        setTimeout(() => {
            this.image = $('.workspace-element');
            this.image.attr('src', this.state.wsElement.src).cropper(cParams);
        }, 100);
    },
    unmountEditImage: function () {
        this.state.editImage = false;
        this.state.editTool = false;
        if (this.toCrop !== false) {
            this.toCrop.destroy();
            this.toCrop = null;
            this.image.data('cropper', this.toCrop);
        }
    },
    applyImageChanges: function () {
        if (!this.toCrop)
            return;
        const mime = 'image/jpeg', cropOption = Object.assign(this.state.editImage.dimensions, { fillColor: 'white' }), base64Encode = this.toCrop.getCroppedCanvas(cropOption).toDataURL(mime);
        this.toWorkspace({
            src: base64Encode,
            size: this.base64Size(base64Encode),
            mime,
            lastModified: Date.now(),
            original: this.state.wsElement.original,
            edited: this.toCrop.getData()
        }, false, true);
        this.unmountEditImage();
    },
    onEditCrop: function () {
        if (!this.toCrop)
            return;
        this.toCrop.crop();
    },
    onEditZoom: function (type) {
        if (!this.toCrop)
            return;
        if (this.state.editImage.zoom && this.state.editImage.zoom >= 2)
            return;
        const value = type == 'in' ? 0.1 : -0.1;
        this.state.editImage.zoom += value;
        this.toCrop.zoom(value);
    },
    onEditRotate: function (direction) {
        if (!this.toCrop)
            return;
        const value = direction == 'right' ? 11.25 : -11.25;
        this.state.editImage.rotate += value;
        this.toCrop.rotate(value);
    },
    onAddFile: function () {
        this.state.wsElement = null;
    },
    onRemoveFile: function (index) {
        this.state.multipleFiles.splice(index, 1);
        this.setStateDirty('multipleFiles');
        if (this.state.activeFileIndex == index)
            this.state.wsElement = null;
    },
    isLink: function (str) {
        return /^http(s?):\/\/(.+)$/.test(str);
    },
    base64ToBlob: function (str) {
        const parts = str.split(';base64,'), imageType = parts[0].split(':')[1], decodedData = window.atob(parts[1]), uInt8Array = new Uint8Array(decodedData.length);
        for (let i = 0; i < decodedData.length; ++i)
            uInt8Array[i] = decodedData.charCodeAt(i);
        return new Blob([uInt8Array], {
            type: imageType,
            name: 'auto'
        });
    },
    base64Size: function (str) {
        const strLen = str.replace(/^data:(.+);base64,/, '').length, sizeInBytes = 4 * Math.ceil(strLen / 3) * 0.5624896334383812;
        return sizeInBytes / 1024;
    },
    formatOutput: function (dataset) {
        if (!dataset.raw && /^data:(.+);base64,/.test(dataset.src)) {
            dataset.base64 = dataset.src;
            dataset.blob = this.base64ToBlob(dataset.base64);
            dataset.src = window.URL.createObjectURL(dataset.blob);
        }
        return dataset;
    },
    checkOutput: function ({raw, src, size, lastModified, original, edited}, index) {
        const asset = this.formatOutput({
            raw,
            src,
            size,
            lastModified
        });
        if (!asset.base64)
            return asset;
        if (this.input.width && this.input.height) {
            if (!original || !edited) {
                this.showAlert(`The image ${ index !== undefined ? 'No.' + index : '' } is required to be resized first.`);
                return;
            }
            const originalRatio = original.width / original.height, editedRatio = edited.width / edited.height;
            if (originalRatio && editedRatio && originalRatio == editedRatio && (original.width == edited.width || original.height == edited.height)) {
                this.showAlert(`Crop the image ${ index !== undefined ? 'No.' + index : '' } or validate the changes you have made first.`);
                return;
            }
        }
        if (this.input.maxSize && size > this.input.maxSize) {
            this.showAlert(`The size of the file ${ index !== undefined ? 'No.' + index : '' } exceed the limit set. Maximum is ${ this.input.maxSize } kb.`);
            return false;
        }
        return asset;
    },
    uploadFiles: async function () {
        const _this = this;
        let toReturn;
        function doUpload(file) {
            return new Promise((resolve, reject) => {
                const data = new FormData();
                Array.isArray(file) ? file.map(each => data.append('file', each)) : data.append('file', file);
                let url = _this.input.endpoint, headers = {};
                if (_this.input.vts == true) {
                    if (!_this.state.vts)
                        return debug('[PosterPlus] Undefined VTS Settings');
                    url = `${ _this.state.vts.server }/transcode?${ _this.input.vtsPath ? 'spaceFolder=' + _this.input.vtsPath : '' }`;
                    headers = _this.state.vts.headers;
                }
                _this.state.uploading = true;
                _this.state.alert = 'Uploading ...';
                Axios.post(url, data, {
                    headers,
                    onUploadProgress: e => {
                        if (!e.lengthComputable)
                            return;
                        let Percent = Math.round(e.loaded / e.total * 100);
                        _this.state.alert = 'Uploading ... ' + Percent + '%';
                        if (Percent == 100)
                            _this.state.alert = 'Compression ...';
                    }
                }).then(({data}) => {
                    _this.state.alert = false;
                    resolve(data);
                }).catch(({request, response, message}) => {
                    let error;
                    if (response)
                        error = response.status + ' > ' + message;
                    else if (request)
                        error = request.status + ' > ' + message;
                    else
                        error = message;
                    console.log('[PosterPlus] Upload Failed: ', error);
                    _this.state.alert = 'Unexpected Uploading Error Occured. Try again';
                    reject(error);
                    setTimeout(() => _this.state.alert = false, 15000);
                });
            });
        }
        try {
            if (Array.isArray(this.state.multipleFiles)) {
                if (!this.state.multipleFiles.length)
                    return;
                toReturn = [];
                const files = [], toReplaceIndexes = [];
                for (let o = 0; o < this.state.multipleFiles.length; o++) {
                    let output = this.state.multipleFiles[o];
                    if (this.isLink(output.src)) {
                        toReturn.push(output);
                        continue;
                    }
                    if (this.input.cropping == 'optional')
                        output = this.formatOutput(this.state.multipleFiles[o]);
                    else {
                        output = this.checkOutput(this.state.multipleFiles[o], o + 1);
                        if (!output)
                            return;
                    }
                    files.push(output.blob || output.raw);
                    toReplaceIndexes.push(o);
                    toReturn.push(output);
                }
                if (files.length) {
                    const {error, links} = await doUpload(files);
                    if (links && links.length)
                        for (let o = 0; o < toReplaceIndexes.length; o++)
                            toReturn[toReplaceIndexes[o]].src = links[o];
                }
            } else {
                if (this.toCrop != null)
                    this.applyImageChanges();
                toReturn = this.state.wsElement;
                if (!this.isLink(toReturn.src)) {
                    if (toReturn.mime && toReturn.mime.includes('image')) {
                        toReturn = this.input.cropping == 'optional' ? this.formatOutput(toReturn) : this.checkOutput(toReturn);
                        if (!toReturn)
                            return;
                    }
                    const {error, links} = await doUpload(toReturn.blob || toReturn.raw);
                    toReturn.src = links[0];
                }
                if (this.input.preview)
                    $(this.input.preview).attr('src', toReturn.src);
            }
            this.allDone(toReturn);
        } catch (error) {
            _this.state.uploading = false;
        }
    },
    allDone: function (toReturn) {
        if (toReturn !== 'auto')
            return this.emit('done', toReturn);
        if (Array.isArray(this.state.multipleFiles)) {
            toReturn = [];
            for (let o = 0; o < this.state.multipleFiles.length; o++) {
                let output = this.state.multipleFiles[o];
                if (this.isLink(output.src)) {
                    toReturn.push(output);
                    continue;
                }
                if (this.input.cropping == 'optional')
                    output = this.formatOutput(this.state.multipleFiles[o]);
                else {
                    output = this.checkOutput(this.state.multipleFiles[o], o + 1);
                    if (!output)
                        return;
                }
                toReturn.push(output);
            }
        } else if (!this.input.endpoint) {
            if (this.toCrop != null)
                this.applyImageChanges();
            toReturn = this.state.wsElement;
            if (!this.isLink(toReturn.src)) {
                if (toReturn.mime && toReturn.mime.includes('image'))
                    toReturn = this.input.cropping == 'optional' ? this.formatOutput(toReturn) : this.checkOutput(toReturn);
                if (!toReturn)
                    return;
            }
            if (this.input.preview)
                $(this.input.preview).attr('src', toReturn.src);
        }
        this.emit('done', toReturn);
    },
    cancelAll: function () {
        this.emit('cancelled');
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/PosterPlus/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_Axios = require("axios"),
    Axios = module_Axios.default || module_Axios,
    module_Cropper = require("cropperjs"),
    Cropper = module_Cropper.default || module_Cropper,
    SearchBar_template = require("../SearchBar/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    SearchBar_tag = marko_loadTag(SearchBar_template),
    Button_template = require("../Button/index.marko"),
    Button_tag = marko_loadTag(Button_template),
    Row_template = require("../Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    Display_template = require("./components/Display.marko"),
    Display_tag = marko_loadTag(Display_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    _preserve_tag = marko_loadTag(require("marko/dist/core-tags/components/preserve-tag")),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    Locale_template = require("../Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_attrs0 = {
        "class": "w-100 d-flex justify-content-center"
      },
    marko_attrs1 = {
        "class": "position-fixed top-0 w-100 h-100 animated fadeIn faster"
      },
    marko_attrs2 = {
        "class": "position-relative zindex-1 w-75 theme-bg shadow-lg"
      },
    marko_attrs3 = {
        "class": "d-none",
        enctype: "multipart/form-data"
      },
    marko_attrs4 = {
        "class": "position-relative p-2",
        style: "height:8vh"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("ce6a65"),
    marko_node0 = marko_createElement("br", null, "13", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "pp-workspace position-relative top-0",
        style: "height:91vh"
      },
    marko_attrs6 = {
        "class": "pp-workspace-tools position-relative p-1 h-10"
      },
    marko_attrs7 = {
        "class": "pp-footer position-relative text-right px-2 pt-1",
        style: "height:9vh"
      },
    marko_attrs8 = {
        "class": "col"
      },
    marko_attrs9 = {
        "class": "col-2 text-center"
      },
    marko_node1 = marko_createElement("i", {
        "class": "bx bx-x font-large-1"
      }, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("div", {
        "class": "text-center",
        style: "margin-top:70%"
      }, "15", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("p", {
          "class": "blue-grey-text"
        }, null, null, 1)
        .t("Loading ..."),
    marko_attrs10 = {
        "class": "position-relative text-center",
        style: "margin-top:70%"
      },
    marko_node3 = marko_createElement("br", null, "19", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "20", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("p", {
        "class": "blue-grey-text"
      }, "21", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("No Assets Found on the Cloud"),
    marko_attrs11 = {
        "class": "list-unstyled text-center px-1"
      },
    marko_attrs12 = {
        "class": "cursor-pointer my-2"
      },
    marko_attrs13 = {
        "class": "w-100 text-center"
      },
    marko_node6 = marko_createElement("br", null, "39", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node7 = marko_createElement("br", null, "40", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node8 = marko_createElement("br", null, "41", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node9 = marko_createElement("br", null, "34", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node10 = marko_createElement("br", null, "35", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node11 = marko_createElement("br", null, "36", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node12 = marko_createElement("i", {
        "class": "bx bx-cloud-download left font-medium-5"
      }, "33", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node13 = marko_createElement("i", {
        "class": "bx bx-laptop left font-medium-5"
      }, "38", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node14 = marko_createElement("i", {
        "class": "bx bx-camera left font-medium-5"
      }, "43", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs14 = {
        "class": "p-50 text-center cursor-pointer"
      },
    marko_attrs15 = {
        "class": "btn-remove-file position-absolute top-0 right-0",
        style: "margin:5px"
      },
    marko_attrs16 = {
        "class": "bx bx-x font-medium-3 p-25 border white black-text rounded-circle"
      },
    marko_node15 = marko_createElement("div", {
        "class": "btn-add rounded p-2"
      }, "51", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("i", {
          "class": "bx bx-plus font-large-3 grey-text"
        }, null, null, 0),
    marko_attrs17 = {
        "class": "d-flex justify-content-center"
      },
    marko_attrs18 = {
        "class": "cursor-pointer",
        title: "Apply Changes"
      },
    marko_attrs19 = {
        "class": "cursor-pointer",
        title: "Cancel Changes"
      },
    marko_attrs20 = {
        "class": "cursor-pointer",
        title: "Zoom in"
      },
    marko_attrs21 = {
        "class": "cursor-pointer",
        title: "Zoom out"
      },
    marko_attrs22 = {
        "class": "cursor-pointer",
        title: "Rotate right"
      },
    marko_attrs23 = {
        "class": "cursor-pointer",
        title: "Rotate left"
      },
    marko_attrs24 = {
        "class": "cursor-pointer d-none",
        title: "Remove Background"
      },
    marko_attrs25 = {
        "class": "cursor-pointer",
        title: "Crop"
      },
    marko_attrs26 = {
        "class": "d-flex justify-content-center"
      },
    marko_attrs27 = {
        "class": "cursor-pointer",
        title: "Edit Image"
      },
    marko_attrs28 = {
        "class": "cursor-pointer",
        title: "Select from Computer"
      },
    marko_attrs29 = {
        "class": "cursor-pointer",
        title: "Select from Cloud"
      },
    marko_attrs30 = {
        "class": "col-md-6 col-5"
      },
    marko_attrs31 = {
        "class": "col"
      },
    marko_node16 = marko_createElement("i", {
        "class": "bx bx-loader-alt icon-spin icon-right font-medium-5",
        style: "color:inherit"
      }, "86", null, 0, 0, {
        i: marko_const_nextId()
      });

require("cropperjs/dist/cropper.css");

require("./jquery.cropper");

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      "class": marko_classValue(("position-" + (input.adaptive ? "absolute" : "fixed")) + " w-100 vh-100 left-0 top-0 d-flex align-items-center center"),
      style: "z-index:2020"
    }, "0", component, null, 1);

  out.be("div", marko_attrs0, "1", component);

  out.e("div", marko_attrs1, "2", component, 0, 0, {
      onclick: __component.d("click", "cancelAll", false)
    });

  out.be("div", marko_attrs2, "3", component);

  Row_tag({
      class: "m-0",
      renderBody: function(out) {
        out.be("div", {
            "class": marko_classValue((("pp-assets border-right col-lg-3 col-md-4 col-8 p-0 " + state.theme.bg) + ([
                "xs",
                "sm",
                "md"
              ].includes(state.screen.media) ? " translate shadow-lg" : "")) + (state.showAssets ? " in" : [
                "xl",
                "lg"
              ].includes(state.screen.media) ? " d-none" : " left"))
          }, "5", component, null, 1);

        out.be("div", marko_attrs4, "6", component);

        Row_tag({
            class: "d-flex align-items-center",
            renderBody: function(out) {
              out.be("div", marko_attrs8, "8", component);

              SearchBar_tag({
                  placeholder: Locale("Search Image")
                }, out, __component, "9", [
                [
                  "query",
                  "onSearchQuery",
                  false
                ],
                [
                  "dismiss",
                  "onDismissSearch",
                  false
                ]
              ]);

              out.ee();

              out.be("div", marko_attrs9, "10", component);

              Button_tag({
                  class: "btn-icon",
                  renderBody: function(out) {
                    out.n(marko_node1, component);
                  }
                }, out, __component, "11", [
                [
                  "click",
                  "closeCDNAssets",
                  false
                ]
              ]);

              out.ee();
            }
          }, out, __component, "7");

        out.n(marko_node0, component);

        out.ee();

        AutoScroll_tag({
            id: "cdn-assets-list",
            class: "position-relative px-2 pb-3",
            height: "92vh",
            renderBody: function(out) {
              if (state.assets == false) {
                out.n(marko_node2, component);
              } else if (state.assets == null) {
                out.e("div", marko_attrs10, "17", component, 4)
                  .e("i", {
                      "class": marko_classValue(("bx bx-cloud-download font-large-2 " + state.theme.color) + "-text")
                    }, "18", component, 0, 1)
                  .n(marko_node3, component)
                  .n(marko_node4, component)
                  .n(marko_node5, component);
              } else {
                out.be("ul", marko_attrs11, "22", component);

                marko_forOf(state.assets, function(asset, index) {
                  var $keyValue$0 = "@" + ("cdn-" + index),
                      $keyScope$0 = "[" + ($keyValue$0 + "]");

                  out.be("li", marko_attrs12, $keyValue$0, component, null, 0, {
                      onclick: __component.d("click", "toWorkspace", false, [
                          asset,
                          false,
                          false
                        ])
                    });

                  Display_tag(marko_assign({
                      mode: "thumbnail"
                    }, asset), out, __component, "23" + $keyScope$0);

                  out.ee();
                });

                out.ee();
              }
            }
          }, out, __component, "14");

        out.ee();

        out.be("div", {
            "class": marko_classValue("pp-middle p-0" + ([
                "xl",
                "lg"
              ].includes(state.screen.media) ? " col" : " col-12"))
          }, "24", component, null, 1);

        out.be("div", marko_attrs5, "25", component);

        Row_tag({
            class: "m-0 pp-workspace-container position-relative h-90",
            style: "box-shadow:0 2px 4px 0 rgba(0, 0, 0, 0.2) inset !important",
            renderBody: function(out) {
              if (state.wsElement !== null) {
                out.be("div", {
                    "class": marko_classValue(("p-0 d-flex align-items-center" + ([
                        "xl",
                        "lg"
                      ].includes(state.screen.media) ? " col" : " col-12")) + ([
                        "xl",
                        "lg"
                      ].includes(state.screen.media) || (!state.multipleFiles) ? " h-100" : " h-80"))
                  }, "27", component, null, 1);

                out.be("div", {
                    "class": "w-100 text-center d-flex justify-content-center",
                    style: marko_styleValue({
                        height: state.wsElement.height || "100%"
                      })
                  }, "28", component, null, 1);

                _preserve_tag({
                    n: true,
                    b: true,
                    i:  state.editImage ,
                    renderBody: function(out) {
                      Display_tag(state.wsElement, out, __component, "29");
                    }
                  }, out, __component, "28");

                out.ee();

                out.ee();
              } else {
                out.be("div", {
                    "class": marko_classValue(("p-0 d-flex align-items-center" + ([
                        "xl",
                        "lg"
                      ].includes(state.screen.media) ? " col" : " col-12")) + ([
                        "xl",
                        "lg"
                      ].includes(state.screen.media) || (!state.multipleFiles) ? " h-100" : " h-80"))
                  }, "30", component, null, 1);

                out.be("div", marko_attrs13, "31", component);

                if (input.cdn && (!state.showAssets)) {
                  out.e("button", {
                      "class": marko_classValue((("btn btn-outline-" + state.theme.btn) + " btn-lg ") + input.btnStyle)
                    }, "32", component, 2, 1, {
                      onclick: __component.d("click", "fromCloud", false)
                    })
                    .n(marko_node12, component)
                    .t(" Select from Cloud");

                  out.n(marko_node9, component);

                  out.n(marko_node10, component);

                  out.n(marko_node11, component);
                }

                out.e("button", {
                    "class": marko_classValue((("btn btn-outline-" + state.theme.btn) + " btn-lg ") + input.btnStyle)
                  }, "37", component, 2, 1, {
                    onclick: __component.d("click", "fromComputer", false)
                  })
                  .n(marko_node13, component)
                  .t(" Select from Computer");

                out.n(marko_node6, component);

                out.n(marko_node7, component);

                out.n(marko_node8, component);

                out.e("button", {
                    "class": marko_classValue((("btn btn-outline-" + state.theme.btn) + " btn-lg d-none ") + input.btnStyle)
                  }, "42", component, 2, 1, {
                    onclick: __component.d("click", "fromCamera", false)
                  })
                  .n(marko_node14, component)
                  .t(" Take a Picture");

                out.ee();

                out.ee();
              }

              if (state.multipleFiles) {
                AutoScroll_tag({
                    class: "pp-files col-xl-1 col-lg-2 col-12" + ([
                        "xl",
                        "lg",
                        "md"
                      ].includes(state.screen.media) ? " h-100" : " h-20"),
                    renderBody: function(out) {
                      out.be("ul", {
                          "class": marko_classValue("py-1 list-" + ([
                              "xl",
                              "lg"
                            ].includes(state.screen.media) ? "unstyled" : "inline d-flex align-items-center"))
                        }, "45", component, null, 1);

                      marko_forOf(state.multipleFiles, function(file, index) {
                        var $keyValue$1 = "@" + ("file-" + index),
                            $keyScope$1 = "[" + ($keyValue$1 + "]");

                        out.be("li", {
                            "class": "position-relative file-item p-50 cursor-pointer",
                            style: marko_styleValue("width: " + ([
                                "xs",
                                "sm",
                                "md"
                              ].includes(state.screen.media) ? "8rem" : "auto"))
                          }, $keyValue$1, component, null, 1);

                        out.e("span", marko_attrs15, "46" + $keyScope$1, component, 1, 0, {
                            onclick: __component.d("click", "onRemoveFile", false, [
                                index
                              ])
                          })
                          .e("i", marko_attrs16, "47" + $keyScope$1, component, 0);

                        out.be("div", null, "48" + $keyScope$1, component, null, 0, {
                            onclick: __component.d("click", "toWorkspace", false, [
                                file,
                                index,
                                false
                              ])
                          });

                        Display_tag(marko_assign({
                            mode: "thumbnail"
                          }, file), out, __component, "49" + $keyScope$1);

                        out.ee();

                        out.ee();
                      });

                      out.e("li", marko_attrs14, "50", component, 1, 0, {
                          onclick: __component.d("click", "onAddFile", false)
                        })
                        .n(marko_node15, component);

                      out.ee();
                    }
                  }, out, __component, "44");
              }
            }
          }, out, __component, "26");

        out.be("div", marko_attrs6, "53", component);

        if (state.editTool == "image") {
          out.be("div", marko_attrs17, "54", component);

          out.e("span", marko_attrs18, "55", component, 1, 0, {
              onclick: __component.d("click", "applyImageChanges", false)
            })
            .e("i", {
                "class": marko_classValue(("bx bx-check-circle font-large-2 " + state.theme.color) + "-text p-1")
              }, "56", component, 0, 1);

          out.e("span", marko_attrs19, "57", component, 1, 0, {
              onclick: __component.d("click", "unmountEditImage", false)
            })
            .e("i", {
                "class": marko_classValue(("bx bx-x-circle font-large-2 " + state.theme.color) + "-text p-1")
              }, "58", component, 0, 1);

          if (!state.editImage.autoCrop) {
            out.e("span", marko_attrs25, "59", component, 1, 0, {
                onclick: __component.d("click", "onEditCrop", false)
              })
              .e("i", {
                  "class": marko_classValue(("bx bx-crop font-large-2 " + state.theme.color) + "-text p-1")
                }, "60", component, 0, 1);
          }

          out.e("span", marko_attrs20, "61", component, 1, 0, {
              onclick: __component.d("click", "onEditZoom", false, [
                  "in"
                ])
            })
            .e("i", {
                "class": marko_classValue(("bx bx-zoom-in font-large-2 " + state.theme.color) + "-text p-1")
              }, "62", component, 0, 1);

          out.e("span", marko_attrs21, "63", component, 1, 0, {
              onclick: __component.d("click", "onEditZoom", false, [
                  "out"
                ])
            })
            .e("i", {
                "class": marko_classValue(("bx bx-zoom-out font-large-2 " + state.theme.color) + "-text p-1")
              }, "64", component, 0, 1);

          out.e("span", marko_attrs22, "65", component, 1, 0, {
              onclick: __component.d("click", "onEditRotate", false, [
                  "right"
                ])
            })
            .e("i", {
                "class": marko_classValue(("bx bx-rotate-right font-large-2 " + state.theme.color) + "-text p-1")
              }, "66", component, 0, 1);

          out.e("span", marko_attrs23, "67", component, 1, 0, {
              onclick: __component.d("click", "onEditRotate", false, [
                  "left"
                ])
            })
            .e("i", {
                "class": marko_classValue(("bx bx-rotate-left font-large-2 " + state.theme.color) + "-text p-1")
              }, "68", component, 0, 1);

          out.e("span", marko_attrs24, "69", component, 1)
            .e("i", {
                "class": marko_classValue(("bx bxs-magic-wand font-large-2 " + state.theme.color) + "-text p-1")
              }, "70", component, 0, 1);

          out.ee();
        } else {
          out.be("div", marko_attrs26, "71", component);

          out.e("span", marko_attrs27, "72", component, 1, 0, {
              onclick: __component.d("click", "mountEditImage", false)
            })
            .e("i", {
                "class": marko_classValue(("bx bx-highlight font-large-2 " + state.theme.color) + "-text p-1")
              }, "73", component, 0, 1);

          out.e("span", marko_attrs28, "74", component, 1, 0, {
              onclick: __component.d("click", "fromComputer", false)
            })
            .e("i", {
                "class": marko_classValue(("bx bx-laptop font-large-2 " + state.theme.color) + "-text p-1")
              }, "75", component, 0, 1);

          if (input.cdn && ((!state.assets) || (!state.assets.length))) {
            out.e("span", marko_attrs29, "76", component, 1, 0, {
                onclick: __component.d("click", "fromCloud", false)
              })
              .e("i", {
                  "class": marko_classValue(("bx bx-cloud-download font-large-2 " + state.theme.color) + "-text p-1")
                }, "77", component, 0, 1);
          }

          out.ee();
        }

        out.ee();

        out.ee();

        out.be("div", marko_attrs7, "78", component);

        Row_tag({
            class: "d-flex align-items-center",
            renderBody: function(out) {
              out.be("div", marko_attrs30, "80", component);

              if (state.alert) {
                out.e("p", {
                    "class": marko_classValue(("font-medium-2 p-1 " + state.theme.color) + "-text")
                  }, "81", component, 1, 1)
                  .t(state.alert, component);
              }

              out.ee();

              out.be("div", marko_attrs31, "82", component);

              out.be("button", {
                  "class": marko_classValue((("btn btn-outline-" + state.theme.btn) + " btn-lg ") + input.btnStyle)
                }, "83", component, null, 1, {
                  onclick: __component.d("click", "cancelAll", false)
                });

              Locale_tag({
                  text: "Cancel"
                }, out, __component, "84");

              out.ee();

              if (state.showDoneBtn) {
                if (input.vts || input.endpoint) {
                  out.be("button", {
                      "class": marko_classValue((("btn btn-" + state.theme.btn) + " btn-lg ml-1 ") + input.btnStyle)
                    }, "85", component, null, 1, {
                      onclick: __component.d("click", "uploadFiles", false)
                    });

                  if (state.uploading) {
                    out.n(marko_node16, component);
                  }

                  Locale_tag({
                      text: "Upload",
                      class: "align-middle"
                    }, out, __component, "87");

                  out.ee();
                } else {
                  out.be("button", {
                      "class": marko_classValue((("btn btn-" + state.theme.btn) + " btn-lg ml-1 ") + input.btnStyle)
                    }, "88", component, null, 1, {
                      onclick: __component.d("click", "allDone", false, [
                          "auto"
                        ])
                    });

                  Locale_tag({
                      text: "Done"
                    }, out, __component, "89");

                  out.ee();
                }
              }

              out.ee();
            }
          }, out, __component, "79");

        out.ee();

        out.ee();
      }
    }, out, __component, "4");

  out.e("form", marko_attrs3, "90", component, 1)
    .e("input", {
        id: "pp-from-computer",
        type: "file",
        multiple: !(!input.multiset),
        accept: input.accepts || "*"
      }, "91", component, 0, 0, {
        onchange: __component.d("change", "mountSelectedFiles", false),
        onsubmit: __component.d("submit", "prevenAutoSubmit", false)
      });

  out.ee();

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
